import { render, staticRenderFns } from "./GenderTable.vue?vue&type=template&id=52fa6279&scoped=true&"
import script from "./GenderTable.vue?vue&type=script&lang=js&"
export * from "./GenderTable.vue?vue&type=script&lang=js&"
import style0 from "./GenderTable.vue?vue&type=style&index=0&id=52fa6279&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa6279",
  null
  
)

export default component.exports
import {QBtn,QMenu,QList,QItem,QItemSection,QToggle,QTable,QTr,QTh,QTd,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QMenu,QList,QItem,QItemSection,QToggle,QTable,QTr,QTh,QTd})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
